import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class AtendimentoProntuariosService {
    constructor(
        private apiService: ApiService
    ) {}
        
    get(id): Observable<any> {
        let url : string = `/atendimento-prontuarios/${id}`
        return this.apiService.get(url)
    }
    
    getAll(dadosFiltro?): Observable<any> {
        let url : string = `/atendimento-prontuarios`
        return this.apiService.get(url, dadosFiltro)
    }

    defineImpresso(id) : Observable<any> {
        return this.apiService.get('/atendimento-prontuarios/defineImpresso/'+id)
    }
    
    post(form) : Observable<any> {
        return this.apiService.post('/atendimento-prontuarios', form)
    }
    
    put(id: string, form) : Observable<any> {
        form._method='PUT'
        return this.apiService.post('/atendimento-prontuarios/'+id, form)
    }
    
    delete(id) {
        return this.apiService.delete('/atendimento-prontuarios/'+id)
    }
}